// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class GetSiteAccountsResponseModel {
    static getAttributeTypeMap() {
        return GetSiteAccountsResponseModel.attributeTypeMap;
    }
}
GetSiteAccountsResponseModel.discriminator = undefined;
GetSiteAccountsResponseModel.additionalProperties = false;
GetSiteAccountsResponseModel.attributeTypeMap = [
    {
        "name": "siteAccounts",
        "baseName": "siteAccounts",
        "type": ""
    },
];
//# sourceMappingURL=getSiteAccountsResponseModel.js.map